import { useTranslation } from "react-i18next";

function Search(props) {
  const { t } = useTranslation();
  return (
    <input
      type="search"
      placeholder={t("search_company_name_and_quotation_no")}
      value={props.searchTerm}
      onChange={props.handleInputChange}
    />
  );
}

export default Search;
